import React, {useEffect, useRef, useState} from 'react';
import {useRecoilState} from "recoil";
import {loadingAtom} from "../atoms";
import Config from "../core/config";
import Cookies from "js-cookie";
import {formatPhoneNumber} from "../core/telephone";
import {validateEmail} from "../core/email";
import {formatCPF, validateCPF} from "../core/cpf";
import {isOver} from "../core/date";
import {useNavigate} from "react-router-dom";

import searchImg from "../img/customer_auto_filling_facilitoy_logo.png"
import {formatLocalDate, parseLocalDate} from "../utils/utils";
import DateSelector from "./DateSelector";
const CustomerAutoFilling_Documents = (props, {onCustomerAdded}) => {
    const navigate = useNavigate();
    const customerKey = Cookies.get('customerKey');
    const [customerKeyValid, setCustomerKeyValid] = useState(false);
    const currentCustomerAutoFilling = Cookies.get('customerAutoFilling');

    const inputTextRg = useRef();
    const inputTextCpf = useRef();
    const inputTextBirthDateDay = useRef();
    const inputTextBirthDateMonth = useRef();
    const inputTextBirthDateYear = useRef();


    const newEntity = {
        id: undefined,
        name: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        cep: '',
        city: '',
        state: '',
        phone: '',
        email: '',
        instagram: '@',
        birthDate: undefined,
        rg: '',
        cpf: '',
        delivery: false,
        spaceBorneDelivery: false,
        howDidYouFindUs: '',
        referral: ''
    };


    const [formData, setFormData] = useState(currentCustomerAutoFilling ? JSON.parse(currentCustomerAutoFilling) : newEntity);

    useEffect(() => {
        // Validate customer key
        if (customerKey) {
            setCustomerKeyValid(true);
        } else {
            setCustomerKeyValid(false);
            navigate(`/autocadastro/linkInvalido`);
            return;
        }
        
        if(inputTextRg.current) {
            inputTextRg.current.focus();
        }
    }, [customerKey, navigate])

    const handleBirthDateChange = (dateStr) => {
        setFormData((prevData) => ({
            ...prevData,
            birthDate: dateStr
        }));
    };
    const handleSaveButtonClick = async () => {

        try {
            if (validateInputs()) {
                await save();
            }
        } catch (error) {
            console.error('Error saving:', error);
            alert('Error ao salvar.');
        }
    };

    function validateInputs() {

        if (!formData.rg || formData.rg === '') {
            alert('Preencha o campo RG.');
            if (inputTextRg.current) {
                inputTextRg.current.focus();
            }
            return false;
        }

        if (!formData.cpfCnpj || formData.cpfCnpj === '') {
            alert('Preencha o campo cpf.');
            if (inputTextCpf.current) {
                inputTextCpf.current.focus();
            }
            return false;
        }

        if (!validateCPF(formData.cpfCnpj)) {
            alert('CPF inválido.');
            if (inputTextCpf.current) {
                inputTextCpf.current.focus();
            }
            return false;
        }

        if (!formData.birthDate || formData.birthDate === '') {
            alert('Preencha o campo data de nascimento.');
            if (inputTextBirthDateDay.current) {
                inputTextBirthDateDay.current.focus();
            }
            return false;
        }

        if (!isOver(parseLocalDate(formData.birthDate), 18)) {
            alert('Data de nascimento inválida. Menor de 18 anos.');
            if (inputTextBirthDateDay.current) {
                inputTextBirthDateDay.current.focus();
            }
            return false;
        }

        if (isOver(parseLocalDate(formData.birthDate), 100)) {
            alert('Data de nascimento inválida. Data muito antiga.');
            if (inputTextBirthDateDay.current) {
                inputTextBirthDateDay.current.focus();
            }
            return false;
        }

        return true;
    }

    async function save() {
        Cookies.set('customerAutoFilling', JSON.stringify(formData));
        navigate('/autocadastro/endereco')
    }


    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    function handleBackButtonClick() {
        navigate(`/autocadastro/nome`);
    }

    return (
        <div>
            <div style={{textAlign: 'center'}}><h2>Ficha Cadastral - Documentos</h2></div>

                <div style={{textAlign: 'center'}}> <img src={searchImg} alt="Logo"/></div>
            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>RG:</div>
                <input ref={inputTextRg} type="text" id="rg" value={formData.rg} name="rg" onChange={handleChange}/>
            </div>

            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>CPF:</div>
                <input ref={inputTextCpf} type="text" id="cpfCnpj" value={formData.cpfCnpj} name="cpfCnpj" maxLength="14"
                       onChange={(e) => {
                           e.target.value = formatCPF(e.target.value);
                           handleChange(e);
                       }}/>
            </div>

            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Data de Nascimento:</div>
                <DateSelector
                    value={formData.birthDate}
                    onChange={handleBirthDateChange}
                    dayRef={inputTextBirthDateDay}
                    monthRef={inputTextBirthDateMonth}
                    yearRef={inputTextBirthDateYear}
                    maxYear={new Date().getFullYear() - 18}
                />
            </div>


            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <button onClick={handleBackButtonClick}>Voltar</button>
                <button onClick={handleSaveButtonClick}>Continuar</button>
            </div>


        </div>
    );
};

export default CustomerAutoFilling_Documents; 